import { FaFileMedicalAlt, FaNotesMedical, FaBookMedical } from "react-icons/fa";
import { GiHealthNormal } from "react-icons/gi";
export const barChartListPageOne = [
  {
    name: "Health Exams - Completed - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "minewiseMedicalExamDue",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  {
    name: "Health Exams - Fit - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "minewiseMedicalExamFit",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  {
    name: "Health Exams - Unfit - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "minewiseMedicalExamUnfit",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "Mine wise Medical Exam Review",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "minewiseMedicalExamReview",
  //   type: "bar",
  // },
  {
    name: "Health Exams - Overdue - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "minewiseMedicalExamOverdue",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  {
    name: "Health Exams - Completed - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "rowiseMedicalExamDue",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  {
    name: "Health Exams - Fit - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "rowiseMedicalExamFit",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  {
    name: "Health Exams - Unfit - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "rowiseMedicalExamUnfit",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  // {
  //   name: "RO wise Medical Exam Review",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "rowiseMedicalExamReview",
  //   type: "bar",
  // },
  {
    name: "Health Exams - Overdue - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "rowiseMedicalExamOverdue",
    type: "stack",
    isMines: true,
    isHo: true,
  },
];
export const barPieChartListPageTwo = [
  {
    title: "IME Status",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamIME",
    type: "pie",
  },
  {
    title: "IME - Fit Count",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamIMEFitCount",
    type: "pie",
  },
  {
    title: "PME Status",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamPME",
    type: "pie",
  },
  {
    title: "PME - Fit Count",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamPMEFitCount",
    type: "pie",
  },
  {
    title: "SME Status",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamSME",
    type: "pie",
  },
  {
    title: "SME - Fit Count",
    yAxisName: "",
    xAxisName: "",
    value: "minewiseMedicalExamSMEFitCount",
    type: "pie",
  },
  {
    title: "Health Examinations Distribution",
    value: "medicalExamDistribution",
  },
  {
    title: "Top 5 Contractors",
    value: "unfitPMEDistributionForTopFiveContractors",
  },
  {
    name: "Health Examinations - Last 12 Months",
    yAxisName: "Count",
    xAxisName: "",
    value: "monthsWiseMedical",
    type: "barWithLabelMonth",
    isMines: true,
  },
];
export const WigetList = [
  {
    name: "IME Completed",
    key: "IMEWidgetCount",
    value: "",
    icon: FaFileMedicalAlt,
  },
  {
    name: "PME Completed",
    key: "PMEWidgetCount",
    value: "",
    icon: FaNotesMedical,
  },
  {
    name: "SME Completed",
    key: "SMEWidgetCount",
    value: "",
    icon: FaBookMedical,
  },
  {
    name: "Fit Percentage",
    key: "totalMedicalExamsCount",
    value: "",
    icon: GiHealthNormal,
  },
  // {
  //   name: "Employee Medical Exam Count",
  //   key: 'employeeMedicalExamCount',
  //   value: '',
  // },
  // {
  //   name: "Contractor Medical Exam Count",
  //   key: 'contractorPersonMedicalExamCount',
  //   value: '',
  // },
];
